export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Medium.22e00c05.eot";